var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgListTextWrap = function SvgListTextWrap(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F3F46",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.333 10h10.834a2.5 2.5 0 0 1 0 5h-5m-5.834 0h2.084M3.333 5h13.334m-5.158 12.5a12.5 12.5 0 0 1-2.211-2.13.586.586 0 0 1-.131-.37m2.342-2.5a12.5 12.5 0 0 0-2.211 2.13.586.586 0 0 0-.131.37"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgListTextWrap);
export default ForwardRef;